import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';

import { FeatureClientProvider } from '@ctct/feature-sdk';

const client = new QueryClient();

export const ClientWrapper = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={client}>
      <FeatureClientProvider>{children}</FeatureClientProvider>
    </QueryClientProvider>
  );
};
